import Component from '../Component';
import * as config from './config';

class Map extends Component {
	constructor() {
		super();

		this.key = 'map-container';
		this.id = 'mapContainer';
	}

	componentDidMount() {
		this.map = L.map(
			this.id,
			config.MAP_CONFIG
		).setView(
			config.INITIAL_VIEW,
			config.INITIAL_ZOOM
		);

		this.tileLayer = L.tileLayer(
			config.TILE_LAYER_URL,
			config.TILE_LAYER_CONFIG
		).addTo(this.map);

		let paneIndex = 310; // could be anything between 200 (tilePane) and 400 (overlayPane)

		for (const pane of config.PANES) {
			this.map.createPane(pane);
			this.map.getPane(pane).style.zIndex = paneIndex;
			paneIndex += 1;
		}

		this.printer = L.easyPrint({
			position: 'bottomleft',
			sizeModes: ['Current', 'A4Portrait', 'A4Landscape'],
			tileLayer: this.tileLayer,
			tileWait: 3000,// wait until background tiles are loaded, to be printed as well
			exportOnly: true,// Do not print, only export map
			hidden: true,
		}).addTo(this.map);
	}

	addLayer(layer) {
		this.map.addLayer(layer);
	}

	removeLayer(layer) {
		this.map.removeLayer(layer);
	}

	printMap() {
		this.printer.printMap('CurrentSize', 'Export');
	}

	getMap() {
		return this.map;
	}

	render() {
		return `
            <div ref="component-${this.key}" id="${this.id}" class="map">
            </div>
        `;
	}
}

export default Map;
